var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActionsCourseEnroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#0072FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4921 15.1198C24.1762 14.9934 23.8238 14.9934 23.508 15.1198L11.8828 19.7699C10.7723 20.2141 10.7723 21.7859 11.8828 22.2301L16 23.877V29.8219C16 30.3156 16.2834 30.7655 16.7286 30.9788C21.3261 33.1809 26.6739 33.181 31.2714 30.9788C31.7167 30.7655 32 30.3156 32 29.8219V23.877L36.1173 22.2301C37.2277 21.7859 37.2277 20.214 36.1173 19.7699L24.4921 15.1198ZM30 24.677L24.4921 26.8802C24.1762 27.0066 23.8238 27.0066 23.508 26.8802L18 24.677V29.3627C21.8209 31.053 26.1792 31.053 30 29.3627V24.677ZM14.1926 21L24 17.077L33.8074 21L24 24.923L14.1926 21Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsCourseEnroll);
export default __webpack_public_path__ + "static/media/actions-course-enroll.0e2cabd0.svg";
export { ForwardRef as ReactComponent };